import { api } from '@/f1/service';
import custom from '@/f1/custom';
import DatePicker from 'vue2-datepicker';
import Language from './language';
import moment from 'moment-timezone'

//restful api
// import { wsfinder as wf } from '@/f1/service/api'; 

//i18n_data
import fields from './i18n_data'

const default_opt = () => ({
  perPage: 10, //limit,
  currentPage: 1, //
  totalRows: 0,
  adv : false,
  sk : '', sv : '', skt : '', opt : {},
  created_at_ed : moment().add(1, 'day'),
  created_at_sd : moment().add(-1, 'month'),
})

export default {
  components : { DatePicker, Language },
  data: () => { return { so : default_opt(), custom, moment, date_check: undefined, year_modal : false, date_modal : false, } },
  computed: {
    fields() { return fields.i18n_fields[this.i18n]; },
    rowCount() { return this.so.totalRows || 0; },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; }
  },
  methods: {
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v, equal=false) {
      if(equal) {
        return { name : k, value : v, op : '=' }
      }
      else if(['level', 'mode'].indexOf(k) > -1) {
        // console.log({ name : k, value : parseInt(v, 10), op : '=' })
        return { name : k, value : parseInt(v, 10), op : '=' };
      } else if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }

      return { name : k, value : `%${v}%`, op : 'like' }
    },
    reset() { this.so = default_opt(); this.$refs._list.refresh(); },
    refresh() { this.$refs._list.refresh();},
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let so = {
        target : 'detect', cmd : 'list',
        body : { sort : [{ name : 'id', op : 'desc'}], or : [], and : [] },
        offset : (this.so.currentPage-1 || 0) * 10, limit: 10, // 10 은 나중에 변수 처리해야함.
      }

      if((!this.so.created_at_sd || !this.so.created_at_ed)){
        this.date_modal = true;
        return this.date_modal
      }

      // 조회 기간 최대 1년
      this.date_check = this.checkdate();
      if(this.date_check > 365){
        this.year_modal = true;

        return this.year_modal
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : ctx.sortDesc && 'desc' } ]; }
      // if(!(this.so.sv || '').trim() && this.so.sk) { so.body.and = [ { name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ] }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
      if(this.so.created_at_ed) { so.body.and.push({ name : 'created_at', value : this.so.created_at_ed, op : '<='}); }
      if(this.so.created_at_sd) { so.body.and.push({ name : 'created_at', value : this.so.created_at_sd, op : '>='}); }


      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'os_type':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'version':
              cond = parseInt(this.so.opt[k[i]]) > 0 ? this.set_op(k[i], this.so.opt[k[i]]) : this.set_op('', '')
              break;
            case 'mode':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'updated_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'updated_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }

      return api.wsfinder.WSFinder(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) );
      //return wf.detect.list(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message : e.statusText));
    },
    detail(item) { this.$router.push(`detect/${item.id}`); },
    checkdate(){  //최대기간 설정
      let sd = moment(this.so.created_at_sd)
      let ed = moment(this.so.created_at_ed)

      let check_date = ed.diff(sd, 'day');
      return check_date
    }
  },
  created() { console.log('detect.vue', 'created'); },
  destroyed() { console.log('detect.vue', 'destroyed'); },
  mounted() { console.log('detect.vue', 'mounted'); },
}
